module.exports = __webpack_public_path__ + "media/images/error-bg-b5b57d246436de43dcd36bf9b5533fb8.png";